import { normalizeId } from './ids';

/**
 * Element sets (docs/plans/element-sets-and-me.md): the reusable element
 * bundles a card attaches beside the hierarchy. The scope grammar is the
 * card's, verbatim: a collection card attaches global sets or its own
 * collection's; a global card attaches global sets only.
 */

/** The route of a set's page. */
export const elementSetPath = set => `/element-sets/${normalizeId(set?._id) || normalizeId(set)}`;

/** The route that creates a set for a collection (or a global one with no collection). */
export const newElementSetPath = collectionId => (collectionId ? `/element-sets/new?collectionId=${normalizeId(collectionId)}` : '/element-sets/new');

/**
 * May a card of this scope attach the set? `collectionId` is the card's
 * owning collection (null for a global card).
 */
export function canCardAttachSet(set, { collectionId = null } = {}) {
	if (!set) return false;
	if (set.scope === 'global') return true;
	if (set.scope === 'collection') {
		const owner = normalizeId(set.collection_id);
		const target = normalizeId(collectionId);
		return !!owner && !!target && owner === target;
	}
	return false;
}

/** The sets a card of a collection (or a global card) may attach, global first, each group by name. */
export function attachableElementSets(elementSets = [], { collectionId = null } = {}) {
	const byName = (a, b) => (a?.name || '').localeCompare(b?.name || '', undefined, { sensitivity: 'base' });
	const list = (elementSets || []).filter(set => canCardAttachSet(set, { collectionId }));
	return [
		...list.filter(set => set.scope === 'global').sort(byName),
		...list.filter(set => set.scope !== 'global').sort(byName),
	];
}

/** How many of `cards` attach the set directly (the API's usage count over the readable cards). */
export function cardsAttachingSet(set, cards = []) {
	const id = normalizeId(set?._id);
	if (!id) return [];
	return (cards || []).filter(card => (Array.isArray(card?.elementSets) ? card.elementSets : []).some(ref => normalizeId(ref) === id));
}
